var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-afterpay"},[_vm._v("\n  or 4 payments of\n  "),_c('price-display',{attrs:{"prices":_vm.priceQuotients,"show-code":false}}),_vm._v("\n  with Afterpay "),_c('br'),_vm._v(" "),_c('button',{staticClass:"product-afterpay__button",on:{"click":function($event){return _vm.$emit('show')}}},[_vm._v("\n    more info\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }